import React from 'react';
import PropTypes from 'prop-types';
import { calendarType, displayRange } from './calendarPresentation';
import SchoolCalendarBreaks from './SchoolCalendarBreaks';
import './schoolCalendar.scss';
import { useTranslation } from 'react-i18next';

export default function SchoolCalendarSummaryCard({ calendar, actions }) {
  const { t: tr, i18n } = useTranslation();
  return (
    <section className="school-calendar-summary school-calendar-panel" aria-label={tr("calendar:schoolCalendarSummary_161")}>
      <div>
        <h2>{tr("common:schoolCalendar")}</h2>
        <p>{tr("common:schoolYear")} {calendar.schoolYearStart}/{calendar.schoolYearStart + 1}</p>
        {calendar.integrationPending && <p>{tr("calendar:informationalCalendarTheseDatesDoNotYetAffectThe_162")}</p>}
        {calendar.status === 'updating' && <p>{tr("calendar:theCalendarIsBeingUpdated_163")}</p>}
        {calendar.teachingPeriod ? <p>{tr("calendar:teachingPeriod_164")} <strong>{displayRange(calendar.teachingPeriod, i18n.language)}</strong></p>
          : <p>{tr("calendar:theCalendarForThisYearHasNotBeenConfigured_165")}</p>}
      </div>
      {calendar.teachingPeriod && (
        <div>
          <h3>{tr("calendar:breaksAndHolidays_150")}</h3>
          <SchoolCalendarBreaks calendar={calendar} />
        </div>
      )}
      {actions && <div className="school-calendar-summary-actions">{actions}</div>}
    </section>
  );
}
SchoolCalendarSummaryCard.propTypes = { calendar: calendarType.isRequired, actions: PropTypes.node };
SchoolCalendarSummaryCard.defaultProps = { actions: null };
